import { CalendarEvent, CalendarSurface } from './types';
import { formatCalendarDateRange, formatCalendarDateWithWeekday } from './utils';

const DEFAULT_CALENDAR_SURFACES: CalendarSurface[] = ['agenda'];

export function calendarEventsForSurface(
  events: CalendarEvent[],
  surface: CalendarSurface,
): CalendarEvent[] {
  return events.filter((event) => (event.displayOn ?? DEFAULT_CALENDAR_SURFACES).includes(surface));
}

export function calendarEventDateLabel(event: CalendarEvent): string {
  return event.dateTemplateKey
    ? formatCalendarDateWithWeekday(event.date)
    : formatCalendarDateRange(event.date, event.dateEnd);
}

export function calendarEventDisciplineTags(event: CalendarEvent): string[] {
  return event.disciplineTags ?? [event.discipline];
}

export function calendarEventMatchesDiscipline(event: CalendarEvent, discipline: string): boolean {
  return discipline === 'all' || calendarEventDisciplineTags(event).includes(discipline);
}
